'use es6';

import { getFullHref } from '../util/History';
import { jsx as _jsx } from "react/jsx-runtime";
const Canonical = ({
  rel = 'canonical',
  to
}) => {
  return /*#__PURE__*/_jsx("link", {
    rel: rel,
    href: getFullHref(to)
  });
};
export default Canonical;